import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}


// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp()

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app, 'us-central1')

// For development, optionally use Firebase Functions emulator
// Comment out this block to use production functions
/*
if (import.meta.env.DEV && !window.location.host.includes('localhost:4000')) {
  const connectToEmulators = () => {
    try {
      // Only connect Functions emulator to avoid CORS issues
      // Other services will still use production Firebase
      connectFunctionsEmulator(functions, 'localhost', 5001)
      console.log('Connected to Firebase Functions emulator')
    } catch (error) {
      console.log('Functions emulator already connected or not available')
    }
  }
  
  // Only connect once
  if (!window.__FIREBASE_EMULATORS_CONNECTED__) {
    connectToEmulators()
    window.__FIREBASE_EMULATORS_CONNECTED__ = true
  }
}
*/

// CORS workaround for development
if (import.meta.env.DEV) {
  // Use a proxy or configure CORS headers
  console.log('Development mode - Firebase functions may have CORS issues')
}

declare global {
  interface Window {
    __FIREBASE_EMULATORS_CONNECTED__?: boolean
    __FIREBASE_FUNCTIONS_EMULATOR_CONNECTED__?: boolean
  }
}